import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    footer: {
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
}));

const Footer = () => {
    const classes = useStyles();

    return (
        <Box className={classes.footer}>
            &copy; 2025 - RackletAI - build 0.5012025
        </Box>
    );
};

export default Footer;